import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./notificationManagementReducer";
import {
  resetPageAndLimit,
  resetSearchFilters,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
} from "../YouTubeManagement/YouTubeManagementActions";

export function getNotificationsList(data, page, limit) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_NOTIFICATION_LIST_PENDING,
      payload: {
        getNotificationListPending: true,
        getNotificationListSuccess: false,
        getNotificationListError: null,
        notificationList: null,
      },
    });
    dispatch(showLoader());

    Api.post(`push/notificationList?page=${page}&limit=${limit}`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_LIST_SUCCESS,
          payload: {
            getNotificationListPending: false,
            getNotificationListSuccess: true,
            getNotificationListError: null,
            notificationList: response.data,
            currentPage: response.data?.page,
            rowsPerPage: {
              label: `${response?.data?.limit}`,
              value: response?.data?.limit,
            },
          },
        });
        dispatch(resetPageAndLimit());
        dispatch(resetSearchFilters());
        dispatch(resetActiveNavigationTab());
        dispatch(resetSearchFilterForVideosByUrl());
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_LIST_ERROR,
          payload: {
            getNotificationListPending: false,
            getNotificationListSuccess: false,
            getNotificationListError: null,
            notificationList: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getNotificationById(id) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_NOTIFICATION_BY_ID_PENDING,
      payload: {
        getNotificationByIdPending: true,
        getNotificationByIdSuccess: false,
        getNotificationByIdError: null,
      },
    });
    dispatch(showLoader());

    Api.get(`push/getNotificationById/${id}`)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_BY_ID_SUCCESS,
          payload: {
            getNotificationByIdPending: false,
            getNotificationByIdSuccess: true,
            getNotificationByIdError: null,
            notificationDataById: response?.data,
          },
        });
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_BY_ID_ERROR,
          payload: {
            getNotificationByIdPending: false,
            getNotificationByIdSuccess: false,
            getNotificationByIdError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function addNewNotification(data, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_NEW_NOTIFICATION_PENDING,
      payload: {
        addNewNotificationPending: true,
        addNewNotificationSuccess: false,
        addNewNotificationError: null,
      },
    });
    dispatch(showLoader());

    Api.post("push/savePushNotification", data)
      .then((response) => {
        console.log("add notification", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_NEW_NOTIFICATION_SUCCESS,
          payload: {
            addNewNotificationPending: false,
            addNewNotificationSuccess: true,
            addNewNotificationError: null,
          },
        });
        callback();
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message,
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_NEW_NOTIFICATION_ERROR,
          payload: {
            addNewNotificationPending: false,
            addNewNotificationSuccess: false,
            addNewNotificationError: null,
          },
        });

        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function editNotification(id, data, callback) {
  // console.log("hi");
  return (dispatch) => {
    dispatch({
      type: actionTypes.EDIT_NOTIFICATION_PENDING,
      payload: {
        editNotificationPending: true,
        editNotificationSuccess: false,
        editNotificationError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`push/updateNotification/${id}`, data)
      .then((response) => {
        // console.log("edit notification", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.EDIT_NOTIFICATION_SUCCESS,
          payload: {
            editNotificationPending: false,
            editNotificationSuccess: true,
            editNotificationError: null,
          },
        });
        callback();
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response?.message,
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.EDIT_NOTIFICATION_ERROR,
          payload: {
            editNotificationPending: false,
            editNotificationSuccess: false,
            editNotificationError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function deleteNotification(id, callback) {
  console.log(id);
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_NOTIFICATION_PENDING,
      payload: {
        deleteNotificationPending: true,
        deleteNotificationSuccess: false,
        deleteNotificationError: null,
      },
    });
    dispatch(showLoader());

    Api.delete(`push/deleteNotification/${id}`)
      .then((response) => {
        console.log("delete user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_NOTIFICATION_SUCCESS,
          payload: {
            deleteNotificationPending: false,
            deleteNotificationSuccess: true,
            deleteNotificationError: null,
          },
        });
        callback();
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message,
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_NOTIFICATION_ERROR,
          payload: {
            deleteNotificationPending: false,
            deleteNotificationSuccess: false,
            deleteNotificationError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function getNotificationsActivityLogList(data, page, limit) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_NOTIFICATION_ACTIVITY_LIST_PENDING,
      payload: {
        getNotificationActivityListPending: true,
        getNotificationActivityListSuccess: false,
        getNotificationActivityListError: null,
      },
    });
    dispatch(showLoader());

    Api.post(`push/activityLogList?page=${page}&limit=${limit}`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_ACTIVITY_LIST_SUCCESS,
          payload: {
            getNotificationActivityListPending: false,
            getNotificationActivityListSuccess: true,
            getNotificationActivityListError: null,
            activityLogList: response?.data,
            currentPageOfActivityLog: page,
            rowsPerPageOfActivityLog: { label: `${limit}`, value: limit },
          },
        });
        // dispatch(resetPageAndLimit());
        // dispatch(resetSearchFilters());
        // dispatch(resetActiveNavigationTab());
        // dispatch(resetSearchFilterForVideosByUrl());
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_NOTIFICATION_ACTIVITY_LIST_ERROR,
          payload: {
            getNotificationActivityListPending: false,
            getNotificationActivityListSuccess: false,
            getNotificationActivityListError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function updateRowsPerPage(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ROWS_PER_PAGE,
      payload: {
        rowsPerPage: data,
      },
    });
  };
}

export function updateRowsPerPageOfActivityLog(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ROWS_PER_PAGE_OF_ACTIVITY_LOG,
      payload: {
        rowsPerPageOfActivityLog: data,
      },
    });
  };
}

export function updateCurrentPage(page) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_CURRENT_PAGE,
      payload: {
        currentPage: page,
      },
    });
  };
}

export function updateCurrentPageOfActivityLog(page) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_CURRENT_PAGE_OF_ACTIVITY_LOG,
      payload: {
        currentPageOfActivityLog: page,
      },
    });
  };
}

export function updateSearchFilters(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_SEARCH_FILTERS,
      payload: {
        fields: data,
      },
    });
  };
}

export function updateSendNotificationTabs(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_TABS,
      payload: {
        activeSendNotificationTab: data,
      },
    });
  };
}

export function sendNotification(data, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SEND_NOTIFICATION_PENDING,
      payload: {
        sendNotificationPending: true,
        sendNotificationSuccess: false,
        sendNotificationError: null,
      },
    });
    dispatch(showLoader());

    Api.post("push/sendPushNotificationToUsers", data)
      // Api.post("push/sendPushNotificationTest", data)
      .then((response) => {
        console.log("send notification", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.SEND_NOTIFICATION_SUCCESS,
          payload: {
            sendNotificationPending: false,
            sendNotificationSuccess: true,
            sendNotificationError: null,
          },
        });
        callback();
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message,
          })
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.SEND_NOTIFICATION_ERROR,
          payload: {
            sendNotificationPending: false,
            sendNotificationSuccess: false,
            sendNotificationError: null,
          },
        });

        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}

export function sendNotificationForPublishedVideos(data, callback) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_PENDING,
      payload: {
        sendNotificationForPublishedVideosPending: true,
        sendNotificationForPublishedVideosSuccess: false,
        sendNotificationForPublishedVideosError: null,
      },
    });
    dispatch(showLoader());

    Api.post("push/sendNotificationOnVideoPublish", data)
      // Api.post("push/sendPushNotificationTest", data)
      .then((response) => {
        console.log("send notification", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_SUCCESS,
          payload: {
            sendNotificationForPublishedVideosPending: false,
            sendNotificationForPublishedVideosSuccess: true,
            sendNotificationForPublishedVideosError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: response.message,
          })
        );
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.SEND_NOTIFICATION_FOR_PUBLISHED_VIDEOS_ERROR,
          payload: {
            sendNotificationForPublishedVideosPending: false,
            sendNotificationForPublishedVideosSuccess: false,
            sendNotificationForPublishedVideosError: null,
          },
        });

        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: err.message,
          })
        );
      });
  };
}
